import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'sign-in',
    pathMatch: 'full'
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./folder/folder.module').then(m => m.FolderPageModule)
  },
  {
    path: 'add-trip-info',
    loadChildren: () => import('./add-trip-info/add-trip-info.module').then(m => m.AddTripInfoPageModule)
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsPageModule)
  },
  {
    path: 'create-trip',
    loadChildren: () => import('./create-trip/create-trip.module').then(m => m.CreateTripPageModule)
  },
  {
    path: 'driver-info',
    loadChildren: () => import('./driver-info/driver-info.module').then(m => m.DriverInfoPageModule)
  },
  {
    path: 'my-profile',
    loadChildren: () => import('./my-profile/my-profile.module').then(m => m.MyProfilePageModule)
  },
  {
    path: 'my-trucks',
    loadChildren: () => import('./my-trucks/my-trucks.module').then(m => m.MyTrucksPageModule)
  },
  {
    path: 'select-locations',
    loadChildren: () => import('./select-locations/select-locations.module').then(m => m.SelectLocationsPageModule)
  },
  {
    path: 'sign-in',
    loadChildren: () => import('./sign-in/sign-in.module').then(m => m.SignInPageModule)
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./sign-up/sign-up.module').then(m => m.SignUpPageModule)
  },
  {
    path: 't-c',
    loadChildren: () => import('./t-c/t-c.module').then(m => m.TCPageModule)
  },
  {
    path: 'trip-info',
    loadChildren: () => import('./trip-info/trip-info.module').then(m => m.TripInfoPageModule)
  },
  {
    path: 'truck-info',
    loadChildren: () => import('./truck-info/truck-info.module').then(m => m.TruckInfoPageModule)
  },
  {
    path: 'verification',
    loadChildren: () => import('./verification/verification.module').then(m => m.VerificationPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'my-driver',
    loadChildren: () => import('./my-driver/my-driver.module').then(m => m.MyDriverPageModule)
  },
  {
    path: 'change-language',
    loadChildren: () => import('./change-language/change-language.module').then(m => m.ChangeLanguagePageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
